const defaultRawDataProcessor = (rawData, metric) => {

    const accumulatorStartObject = {localProcessedDataList: [], totalValue: 0};
    const reducingFn = (accumulator, currentValue) => {
        //     expected type
        //     {
        //       "policy": "Full_Final_Backup",
        //       "bytes": 18512474206,
        //       "files": 421160
        //     }
        const categoryName = currentValue.policy;
        const metricValue = metric === "Size" ? currentValue?.bytes ?? 0 : currentValue?.files ?? 0;
        accumulator.localProcessedDataList.push([categoryName, metricValue]);
        accumulator.totalValue += metricValue;
        return accumulator;

    };
    const {localProcessedDataList, totalValue} = rawData.reduce(reducingFn, accumulatorStartObject);
    return {processedData: localProcessedDataList, processedDataTotal: totalValue};
};


const storagePoliciesRawDataProcessor = (rawData, metric) => {
    const accumulatorStartObject = {localProcessedDataList: [], totalValue: 0};
    const reducingFn = (accumulator, currentValue) => {
        //     expected type
        //     {
        //       "policy": "Full_Final_Backup",
        //       "bytes": 18512474206,
        //       "files": 421160
        //     }
        const categoryName = currentValue.policy;
        const metricValue = metric === "Size" ? currentValue?.bytes ?? 0 : currentValue?.files ?? 0;
        accumulator.localProcessedDataList.push([categoryName, metricValue]);
        accumulator.totalValue += metricValue;
        return accumulator;

    };
    const {localProcessedDataList, totalValue} = rawData.reduce(reducingFn, accumulatorStartObject);
    return {processedData: localProcessedDataList, processedDataTotal: totalValue};
};

const backupRawDataProcessor = (rawData, metric) => {
    const accumulatorStartObject = {localProcessedDataList: [], totalValue: 0};
    const reducingFn = (accumulator, currentValue) => {
        //     expected type
        // "158": {
        //         "count": 2,
        //         "data": [
        //             {"format": "Commvault", "bytes": 39138673791, "files": 4747},
        //             {"format": "Netbackup", "bytes": 53883407202, "files": 4655}]
        //     }
        const categoryName = currentValue.format;
        const metricValue = metric === "Size" ? currentValue?.bytes ?? 0 : currentValue?.files ?? 0;
        accumulator.localProcessedDataList.push([categoryName, metricValue]);
        accumulator.totalValue += metricValue;
        return accumulator;

    };
    const {localProcessedDataList, totalValue} = rawData.reduce(reducingFn, accumulatorStartObject);
    return {processedData: localProcessedDataList, processedDataTotal: totalValue};
};

export const variantRawDataProcessorMapDonutGraph = {
    defValue: defaultRawDataProcessor,
    backup: backupRawDataProcessor,
    storagePolicies: storagePoliciesRawDataProcessor,
};
